import React from 'react';
import MainLayout from '../components/MainLayout';
import { Link } from 'react-router-dom';
import whoweare from '../assets/images/img/who-we-are.jpg';
import { IoMdTime } from "react-icons/io";
import { FaMobileAlt } from "react-icons/fa";
import { PiCalendarCheck } from "react-icons/pi";
import { IoSpeedometerOutline } from "react-icons/io5";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { FaCreditCard } from "react-icons/fa";
import { BsQuestionCircle } from "react-icons/bs";
import { FiDollarSign } from "react-icons/fi";
import { MdDownloadDone } from "react-icons/md";
import { FaGlobeAmericas } from "react-icons/fa";
import { IoAirplane } from "react-icons/io5";
import { FaBed } from "react-icons/fa";
import { FaUmbrellaBeach } from "react-icons/fa";
import { FaStamp } from "react-icons/fa";



export default function TravelTourismB2B() {
  return (
    <>
    <MainLayout>

    <div className='breadcrumb_area'>
    <div className='photo'>
    <img src={whoweare} alt=''/>
      <div className='wrapper'> 
          <div className='container'>
          <div className='row'>
          <div className='col-12'>
          <h1 className='breadcrumb_title'>B2B Travel Portal</h1>
          <ul className="breadcrumb_list">
          <li className="breadcrumb_item"><Link to='/'>Home</Link></li>
          <li className="breadcrumb_item">Travel & Tourism B2B</li>                 
          </ul>
          </div>
          </div>
          </div>  
      </div>
    </div>


    </div>


    <div className='inner_page_content travel_tourism_b2b'> 
    <div className='container'>

        <div className='row'>

          <div className='col-12'>
          
          <h2 className='mb-3'>B2B Travel Portal</h2>
              
      <p>B2B Travel Portal is an online travel booking platform with flights, hotels, Holiday packages, insurance, visa and travel related products designed for travel agents to book flights, hotels, and other travel related products as well as manage back office operations such as reservations, inventory, and itinerary creation through a single platform.</p>        
      <p>We develop the best B2B travel portal, which is a one-stop solution for all travel agent requirements.</p> 
      <p>It comes with the best inventory from over multiple suppliers across hotels, flights, tours, activities, car rentals, and payment gateways to enhance the customer experience and increase bookings.</p>

          </div>

          <div className='col-lg-12 mt-4'>
        <h3>What are the benefits of the B2B module?</h3>
        <h6>Benefits of B2B module:</h6>


          </div>

          <div className='col-lg-12 mt-3'>

          <div className='benifits_of_b2b_module'> 
            
              <div className='row'>

            <div className='col-lg-6'>

              <div className='bobm'>
              <div className='icon me-4'><IoMdTime /></div>
              <div className='title'>Real-time Booking Management</div>

              </div>

            </div>
            <div className='col-lg-6'>

<div className='bobm'>
<div className='icon me-4'><FaMobileAlt  /></div>
<div className='title'>Mobile Friendly Design</div>

</div>

          </div>

          <div className='col-lg-6'>

          <div className='bobm'>
          <div className='icon me-4'><PiCalendarCheck  /></div>
          <div className='title'>Automated Booking Confirmation</div>

          </div>

          </div>

          <div className='col-lg-6'>

          <div className='bobm'>
          <div className='icon me-4'><IoSpeedometerOutline /></div>
          <div className='title'>Fully Customization System</div>

          </div>

          </div>

          <div className='col-lg-6'>

          <div className='bobm'>
          <div className='icon me-4'><FaRegMoneyBillAlt /></div>
          <div className='title'>Saved time and money</div>

          </div>

          </div>

          <div className='col-lg-6'>

          <div className='bobm'>
          <div className='icon me-4'><FaCreditCard /></div>
          <div className='title'>Multiple Payment Integration</div>

          </div>

          </div>

          <div className='col-lg-6'>

          <div className='bobm'>
          <div className='icon me-4'><BsQuestionCircle /></div>
          <div className='title'>Multilanguage support</div>

          </div>

          </div>

          <div className='col-lg-6'>

          <div className='bobm'>
          <div className='icon me-4'><FiDollarSign /></div>
          <div className='title'>Multicurrency support</div>

          </div>

          </div>

          <div className='col-lg-6'>

          <div className='bobm'>
          <div className='icon me-4'><MdDownloadDone /></div>
          <div className='title'>Easily set up Markup</div>

          </div>

          </div>

          <div className='col-lg-6'>

          <div className='bobm'>
          <div className='icon me-4'><FaGlobeAmericas /></div>
          <div className='title'>Largest Network in the Global environment</div>

          </div>

          </div>


              </div>



          </div>

          </div>   

          <div className='col-lg-12 mt-5'>

          <h4 className='mb-3'>Which are the best features of a B2B Travel Portal And Why a Travel Agent uses a B2B Travel Portal?</h4>
          <h6>B2B Travel Portal Features:</h6>

            <ul className='b2b_features_list'>

            <li>Agent registration/login </li>
            <li>Define agent's type – Cash or Credit</li>
            <li>Define agent's type – Cash or Credit</li>
            <li>Create sub-agent (s)</li>
            <li>Set profile of agents</li>
            <li>Build own package</li>
            <li>Agent wise mark up</li>
            <li>Flexible markup & commission settings</li>
            <li>Check Booking</li>
            <li>Cancel Booking</li>
            <li>Issue online voucher</li>
            <li>Invoice & receipts</li>
            <li>Payment Gateway Integration</li>
            <li>Auto alerts on confirmation, bookings, tickets</li>
            <li>Comprehensive MIS reports</li>
            <li>Mobile responsive Design</li>
            <li>User friendly interface</li>
            <li>Real Time Reporting</li>

            </ul>

          </div>


            <div className='col-lg-12 mt-5'>

            <div className='b2b_products'>

              <div className='product text-center'>
                  <span> <IoAirplane/> </span>
                  <h5>Flight Search</h5>
                  <p>Find the best deals on the flight with multiple flight options.</p>
                
              </div>
              
              <div className='product text-center'>
                  <span> <FaBed/> </span>
                  <h5>Hotel Search</h5>
                  <p>Find a worldwide hotel and give the best options to your customer.</p>
                
              </div>

              <div className='product text-center'>
                  <span> <FaUmbrellaBeach/> </span>
                  <h5>Holiday Packages</h5>
                  <p>Find the best options for tours and experiences in multiple locations.</p>
                
              </div>

              <div className='product text-center'>
                  <span> <FaStamp/> </span>
                  <h5>Visa Assistance</h5>
                  <p>Multiple car transfer options where the customer can choose his comfort level.</p>
                
              </div>

            </div>

            </div>

        </div>


    </div>    
    </div>    


    </MainLayout>
    </>
  )
}
